import './lit-suppress';

import { Suspense, lazy } from 'react';
import { getInitialPathname, normalizePathname } from './routing';
import { useLandingPage } from './useLandingPage';
import { OverviewPage } from './pages/OverviewPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PasswordGate } from './components/PasswordGate';

const LandingPage = lazy(() =>
  import('./pages/LandingPage').then((module) => ({
    default: module.LandingPage,
  })),
);

function PageSkeleton() {
  return (
    <div
      aria-hidden="true"
      style={{
        minHeight: '100vh',
        background: 'var(--ts-semantic-color-background-base-default)',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '32px 24px 64px',
        }}
      >
        <div
          style={{
            height: '28px',
            width: '120px',
            borderRadius: '999px',
            background: 'rgba(11, 37, 59, 0.08)',
            marginBottom: '32px',
          }}
        />
        <div
          style={{
            height: '420px',
            borderRadius: '24px',
            background:
              'linear-gradient(90deg, rgba(11, 37, 59, 0.06) 25%, rgba(11, 37, 59, 0.12) 37%, rgba(11, 37, 59, 0.06) 63%)',
            backgroundSize: '400% 100%',
            animation: 'page-skeleton-shimmer 1.4s ease-in-out infinite',
            marginBottom: '40px',
          }}
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '24px',
          }}
        >
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              style={{
                height: '180px',
                borderRadius: '20px',
                background:
                  'linear-gradient(90deg, rgba(11, 37, 59, 0.06) 25%, rgba(11, 37, 59, 0.12) 37%, rgba(11, 37, 59, 0.06) 63%)',
                backgroundSize: '400% 100%',
                animation: 'page-skeleton-shimmer 1.4s ease-in-out infinite',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const pathname = getInitialPathname();
  const page = useLandingPage(pathname);
  const isOverviewPage = normalizePathname(pathname) === 'overview';

  return (
    <PasswordGate>
      <Suspense fallback={<PageSkeleton />}>
        {isOverviewPage ? <OverviewPage /> : page ? <LandingPage blocks={page.body} /> : <NotFoundPage />}
      </Suspense>
    </PasswordGate>
  );
}
